<template>
  <router-view/>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: "WidgetAccount",
  props: {
    baseUrl: String,
    tags: String,
    vueWidgetErgebnisliste: String,
    moreInfoLink: String
  }
})
</script>
